import {
  consumeLocalUrlPromoCode,
  useLocalTags,
  useLocalUrlPromoCode,
} from '@iheartjane/cart/utils';

import { useCustomerSelector } from '@jane/monolith/customer/redux';
import { selectEmbeddedApp } from '@jane/monolith/customer/redux/embeddedApp';
import { useEcommApp } from '@jane/shared/providers';

/** The utm tags for the current app mode and partner, or `undefined`. */
export const useCartTags = () => {
  const { appMode } = useEcommApp();
  const { partnerId } = useCustomerSelector(selectEmbeddedApp);

  return useLocalTags(appMode, partnerId);
};

/** The URL promo code for the current scope, and a consume for once it's submitted. */
export const useUrlPromoCode = () => {
  const { appMode } = useEcommApp();
  const { partnerId } = useCustomerSelector(selectEmbeddedApp);
  const urlPromoCode = useLocalUrlPromoCode(appMode, partnerId);

  return {
    consumeUrlPromoCode: () => consumeLocalUrlPromoCode(appMode, partnerId),
    urlPromoCode,
  };
};
